import React, { useEffect, useState } from "react";
import axios from "axios";
import "./NotOpen.scss";
import { withTranslation } from "react-i18next";
import url from "../../url.json";
import Loader from "../../components/Loader/Loader";
import headers from "../../config/headers";
import dateFormat from "dateformat";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { noticReducer } from "../../Redux/Reducers/notic";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";

function NotOpen({ t }) {
  const lan = useSelector((state) => state.langReducer);
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  useEffect(() => {
    axios
      .get(url.url + `/notice/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        setData(res.data.data);
        dispatch(noticReducer(res.data.data.text));
      })
      .catch((err) => {
        if (!err.response) return toast.error(t("Something went wrong"));
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
      });
  }, [lan]);
  const app = data?.application;
  return (
    <div className="ntv">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Notifications")}</title>
      </Helmet>

      <button type="button" className="ntv__back" onClick={() => navigate("/account/notic")}>
        <i className="bx bx-arrow-back" />
        {t("Notifications")}
      </button>

      {!data ? (
        <div className="ln-cab__empty">
          <Loader />
        </div>
      ) : (
        <article className="ntv__card">
          <header className="ntv__head">
            <span className="ntv__icon" aria-hidden="true">
              <i className="bx bxs-bell-ring" />
            </span>
            <div className="ntv__titles">
              <h1>{data.text || data.message}</h1>
              <div className="ntv__meta">
                {data.department ? (
                  <span><i className="bx bx-buildings" />{data.department}</span>
                ) : (
                  ""
                )}
                {app?.code ? (
                  <span><i className="bx bx-file" />{t("Applic")}: {app.code}</span>
                ) : (
                  ""
                )}
                <span><i className="bx bx-calendar" />{dateFormat(data.created_at, "dd.mm.yyyy HH:MM")}</span>
              </div>
            </div>
          </header>

          {data.message && data.message !== data.text ? <p className="ntv__body">{data.message}</p> : ""}

          <footer className="ntv__actions">
            {app?.id ? (
              <button
                type="button"
                className="ln-btn ln-btn_primary"
                onClick={() => navigate(`/account/applications/show?id=${app.id}`)}
              >
                <i className="bx bx-show" />
                {t("ln_open_application")}
              </button>
            ) : (
              ""
            )}
            <button type="button" className="ln-btn ln-btn_outline" onClick={() => navigate("/account/notic")}>
              {t("ln_all_notifications")}
            </button>
          </footer>
        </article>
      )}
    </div>
  );
}
export default withTranslation()(NotOpen);
